import { Controller } from '@hotwired/stimulus';

export default class ScrollFocusedIntoViewController extends Controller {
  scrollFocused(event) {
    event.target.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  }
}
